import React from 'react';
import { useDispatch } from 'react-redux';
import { updateSelectedDocuments } from '.';

export default function useUpdateSelectedDocuments() {
  const dispatch = useDispatch();
  return React.useCallback(payload => dispatch(updateSelectedDocuments(payload)), [dispatch]);
}